const en = {
        translation: {
          // Trucks 
          title: "Trucks",
          intro: {
            main_text: "Guarantee of your success",
            text_1: "At MMSH Logistics, we understand that the demand for reliable and efficient road freight services remains consistently high across the globe. Our truck transport services allow for flexible scheduling, independent of port, airport, or railway station.Before crafting a tailored solution and mapping out the best route, our experienced logistics team carefully evaluates each request. We pride ourselves on respecting our clients' time, which is why we use the latest GPS and GLONASS technologies to track shipments."
          },

          more_info: "More Information",

          projects: {
            title: "Completed Projects",
            items: [
              { title: "Global Driver Shortage." },
              { title: "Digital solutions for your help." },
              { title: "New marine shipping routes." },
              { title: "Turkey earthquakes effect." }
            ]
          },

          completed_projects: {
            title: "COMPLETED PROJECTS",
            items: [
              { title: "New Port is ready to serve you." },
              { title: "Guarantee of business." },
              { title: "Our ships started working with USA." }
            ]
          },
          // Trucks
          // Trains
          title_2: "Trains",
          intro_2: {
            main_text_2: "Quick delivery with Reil Freight",
            text_1: "At MMSH Logistics, we recognize the growing demand for fast, cost-effective, and environmentally friendly rail freight solutions. Our railway transport services offer seamless, high-capacity shipping across vast distances, ensuring both efficiency and sustainability. Before designing a customized logistics plan, our expert team carefully evaluates each request, optimizing routes for maximum speed and cost savings. By leveraging advanced tracking technologies like GPS and GLONASS, we provide real-time shipment visibility, giving our clients confidence in every mile of the journey."
          },

        

          projects_2: {
            title: "Completed Projects",
            items: [
              { title: "Digitalization of our services." },
              { title: "More trade with Europe." },
              { title: "New trains from Japan are ready." },
              { title: "Salary growth for our employees." }
            ]
          },

          completed_projects_2: {
            title: "COMPLETED PROJECTS",
            items: [
              { title: "Introducing our new office in Ohio." },
              { title: "Now, cargo delivery is quicker." },
              { title: "Strengthening our trade with Beijing." },
              { title: "Use our new mobile app for logistics." }
            ]
          },
          // Trains
          // Air
          title_3: "Air",
          intro_3: {
            main_text_3: "Fast and Reliable Air Freight Solutions",
            text_1: "With access to an extensive network of international carriers, we offer flexible scheduling, priority handling, and customized logistics solutions for businesses of all sizes. Whether it's urgent cargo, high-value goods, or temperature-sensitive shipments, we ensure they are transported with the highest standards of safety and care. By integrating real-time tracking technologies such as GPS and advanced logistics systems, we provide complete shipment visibility from departure to arrival. Our dedicated team optimizes routes for maximum efficiency and cost savings, delivering a seamless air freight experience. With MMSH Logistics, the world is within reach. Where speed matters, we deliver."
          },


          projects_3: {
            title: "Completed Projects",
            items: [
              { title: "Reliable partnership with MMSh." },
              { title: "Fastest delivery to other continents." },
              { title: "Affordable and swift shipment through air." },
            ]
          },

          completed_projects_3: {
            title: "COMPLETED PROJECTS",
            items: [
              { title: "Partnership with international companies." },
              { title: "We started working with South America." }
            ]
          },
          // Air
          // Boats
          title_4: "Ships",
          intro_4: {
            main_text_4: "Seamless & Reliable Sea Freight Solutions",
            text_1: "With access to a vast global network of shipping carriers and ports, we provide flexible scheduling, secure handling, and tailored logistics solutions for businesses of all sizes. Whether it’s bulk cargo, oversized equipment, or temperature-sensitive goods, we ensure safe and efficient maritime transport across international waters. By leveraging advanced tracking technologies, including GPS, AIS (Automatic Identification System), and satellite monitoring, we offer real-time shipment visibility from port to port. Our expert team optimizes routes to minimize transit times and reduce costs, ensuring smooth and timely deliveries."
          },

  

          projects_4: {
            title: "Completed Projects",
            items: [
              { title: "New ports are open for trade." },
              { title: "Well regulated safety programs." },
              { title: "Comfortable shipping through sea." },
            ]


          },
          completed_projects_4: {
            title: "COMPLETED PROJECTS",
            items: [
              { title: "Establishing partnership with port in Hong Kong." },
              { title: "Quick transportation with MMSH." }
            ]
          },
          // Boats
          // Multimodal
          title_5: "Multimodal",
          intro_5: {
            main_text_5: "Integrated & Efficient Multimodal Freight Solutions",
            text_1: "Combining the strengths of air, sea, road, and rail transport, we offer seamless multimodal logistics solutions tailored to your business needs. Our flexible scheduling and secure handling ensure efficient movement of goods across borders and continents. Whether it's containerized cargo, oversized equipment, or temperature-sensitive shipments, we optimize routes to minimize transit times and costs. Leveraging advanced tracking technologies, including GPS, AIS, and satellite monitoring, we provide real-time visibility at every stage of the journey. Our expert team ensures smooth coordination between transport modes for timely and cost-effective deliveries."
          },

    

         projects_5: {
            title: "Completed Projects",
            items: [
              { title: "Expansion of our global trade routes." },
              { title: "Implementation of AI-driven systems." },
              { title: "Optimization of multimodal freight solutions." },
              { title: "Development of sustainable shipping practices." },
            ]
          },

          completed_projects_5: {
            title: "COMPLETED PROJECTS",
            items: [
              { title: "Strategic alliance with a port in Hong Kong." },
              { title: "Faster logistics with MMSH Express Service." },
            ]
          },

          // Multimodal
          // Chemicals
            title_6: "Chemicals",
            intro_6: {
              main_text_6: "Safe, Efficient & Compliant Chemical Logistics",
              text_1: "MMSH Logistics specializes in the secure and efficient transportation of chemical loads, ensuring full compliance with international safety regulations. Our multimodal transport solutions—covering road, sea, rail, and air—provide seamless shipping for hazardous and non-hazardous chemicals. We work with industry leaders to provide safe handling, temperature-controlled storage, and specialized transport methods. Our expert team manages all necessary documentation and compliance requirements, ensuring smooth customs clearance and regulatory adherence in international markets. By leveraging advanced tracking technologies, we provide full visibility throughout the supply chain, offering a reliable and cost-effective solution for chemical logistics."
            },
           
            projects_6: {
              title: "Advancements in Chemical Freight Solutions",
              items: [
                { title: "Global expansion of chemical transport routes." },
                { title: "AI-driven tracking for hazardous materials." },
                { title: "Optimized multimodal logistics for chemicals." },
                { title: "Eco-friendly solutions for chemical shipping." }
              ]
            },
            completed_projects_6: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "New chemical logistics hub in Europe." },
                { title: "AI-powered monitoring for safety compliance." },
              ]
            },
            // Chemicals

            // Technology
            title_9: "Technology",
            intro_9: {
              main_text_9: "Secure & High-Speed Logistics for the Technology Industry",
              text_1: "MMSH Logistics provides tailored transportation solutions for high-value technology products, including electronics, semiconductors, and data servers. We understand that the tech industry requires not only fast deliveries but also highly secure and climate-controlled transport to protect sensitive components. Our logistics network ensures safe handling, real-time monitoring, and expedited shipping for just-in-time manufacturing and distribution. With our AI-powered tracking and multimodal solutions, we reduce transit times and operational costs, allowing businesses to optimize supply chain efficiency. Whether you need express air freight for urgent shipments or secure containerized transport for bulk electronics, we offer customizable solutions to meet your needs."
            },
            
            projects_9: {
              title: "Advancements in Tech Freight Solutions",
              items: [
                { title: "Expansion of secure warehouses for electronics." },
                { title: "IoT sensors for real-time cargo tracking." },
                { title: "Optimized logistics for semiconductor supply." },
                { title: "Advanced security for high-value shipments." }
              ]
            },
            completed_projects_9: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "Secure global network for semiconductor logistics." },
                { title: "AI-driven monitoring for sensitive tech shipments." },
              ]
            },
            // Technology
            // Groceries
            title_10: "Groceries",
            intro_10: {
              main_text_10: "Fast & Fresh Logistics for Grocery Supply Chains",
              text_1: "MMSH Logistics provides temperature-controlled and time-sensitive transportation solutions for grocery distribution. We specialize in fresh produce, dairy, meat, frozen goods, and dry food items, ensuring that perishable products maintain their quality from farm to shelf. Our advanced cold chain logistics include climate-controlled storage, real-time temperature monitoring, and express delivery networks. Whether it's large-scale supermarket distribution or small-batch deliveries for local markets, we optimize supply chains to prevent spoilage, reduce waste, and maximize efficiency. With multimodal transport options, including refrigerated trucking, air freight, and express last-mile solutions, we guarantee freshness, reliability, and compliance with food safety regulations."
            },
           
            projects_10: {
              title: "Innovations in Grocery Logistics",
              items: [
                { title: "Expansion of refrigerated transport fleet." },
                { title: "AI-driven supply chain optimization." },
                { title: "Advanced packaging for extended shelf life." },
                { title: "Sustainable logistics for organic food products." }
              ]
            },
            completed_projects_10: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "Developed a temperature-controlled network for groceries." },
                { title: "Integrated AI-driven demand forecasting for fresh produce." },
              ]
            },
            //Groceries


            // Pharmaceuticals
            title_11: "Pharmaceuticals",
            intro_11: {
              main_text_11: "Temperature-Controlled & Compliant Logistics for Pharmaceuticals",
              text_1: "MMSH Logistics specializes in pharmaceutical transportation, ensuring that temperature-sensitive medications, vaccines, and medical supplies reach their destinations safely and efficiently. We utilize advanced cold-chain logistics with real-time temperature monitoring, ensuring compliance with WHO and GDP regulations. Our team is trained in handling pharmaceutical products with extreme care, providing risk-free transport solutions for hospitals, pharmacies, and medical distributors. From temperature-controlled storage to expedited last-mile delivery, we guarantee that critical healthcare products are transported under optimal conditions, minimizing risks and delays."
            },
            
            projects_11: {
              title: "Advancements in Pharma Freight Solutions",
              items: [
                { title: "Expansion of temperature-controlled warehouses." },
                { title: "Blockchain for secure medical tracking." },
                { title: "AI-powered logistics for vaccine transport." },
                { title: "Emergency logistics for urgent medical shipments." }
              ]
            },
            completed_projects_11: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "Secure vaccine distribution across continents." },
                { title: "AI-driven risk management for pharma logistics." },
              ]
            },
            // Pharmaceuticals

            // Fashion
            title_12: "Fashion",
            intro_12: {
              main_text_12: "Fast & Flexible Logistics for the Fashion Industry",
              text_1: "MMSH Logistics provides tailored freight solutions for the fashion industry, ensuring timely and efficient transportation of textiles, apparel, and accessories. We understand that speed and precision are essential in this industry, where seasonal trends and fast-changing demands require agile logistics. Our network includes express air freight, dedicated trucking, and efficient warehousing to support fashion brands in delivering products to global markets on schedule. With our smart inventory management solutions and AI-powered demand forecasting, we help businesses optimize supply chains, minimize excess inventory, and enhance sustainability through eco-friendly transport options."
            },
            
            projects_12: {
              title: "Advancements in Fashion Logistics",
              items: [
                { title: "Expanded global fashion distribution routes." },
                { title: "Real-time tracking for apparel shipments." },
                { title: "Optimized supply chains for fast fashion." },
                { title: "Eco-friendly logistics for sustainable brands." }
              ]
            },
            completed_projects_12: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "Express logistics for seasonal fashion releases." },
                { title: "AI-driven demand forecasting for apparel brands." },
              ]
            },
            //Fashion
            // Agricultural
            title_13: "Agricultural",
            intro_13: {
              main_text_13: "Reliable & Sustainable Logistics for Agriculture",
              text_1: "MMSH Logistics specializes in the transportation of agricultural products, including grains, fresh produce, fertilizers, and livestock feed. Our comprehensive logistics network ensures efficient farm-to-market delivery, supporting food producers, wholesalers, and exporters. With temperature-controlled transport, specialized bulk carriers, and just-in-time distribution, we minimize spoilage and reduce transit times. Our multimodal approach integrates road, rail, sea, and air transport to provide flexible shipping options for seasonal crops and perishable goods. By leveraging AI-driven demand forecasting and blockchain traceability, we optimize supply chains and ensure compliance with global food safety standards. From local farming cooperatives to large-scale agricultural exporters, MMSH Logistics delivers innovative and eco-friendly logistics solutions tailored to the industry's needs."
            },
           
            projects_13: {
              title: "Advancements in Agricultural Logistics",
              items: [
                { title: "Expansion of cold chain transport for perishable crops." },
                { title: "AI-powered inventory forecasting for farming cooperatives." },
                { title: "Optimized multimodal transport for bulk grain exports." },
                { title: "Eco-friendly packaging solutions for organic produce." }
              ]
            },
            completed_projects_13: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "Developed farm-to-market express distribution networks." },
                { title: "Integrated blockchain technology for supply chain traceability." },
              ]
            },
            // Agricultural
            //Construction
            title_14: "Construction",
            intro_14: {
              main_text_14: "Heavy-Duty & Efficient Logistics for the Construction Industry",
              text_1: "MMSH Logistics specializes in the transportation of construction materials, including cement, steel, lumber, heavy machinery, and prefabricated structures. Our logistics solutions support large-scale infrastructure projects, residential developments, and commercial construction by ensuring the timely and cost-effective delivery of essential materials. We utilize specialized heavy-haul trucking, bulk rail freight, and multimodal transport to handle oversized and weight-sensitive cargo. Our logistics experts provide just-in-time delivery coordination, helping construction sites reduce storage costs and maintain project timelines. From raw materials to high-tech modular buildings, MMSH Logistics optimizes supply chains, mitigates delays, and ensures regulatory compliance across international markets."
            },
           
            projects_14: {
              title: "Advancements in Construction Logistics",
              items: [
                { title: "Expansion of specialized heavy-haul transport fleets." },
                { title: "AI-powered logistics for project site deliveries." },
                { title: "Optimized multimodal shipping for prefabricated structures." },
                { title: "Sustainable supply chain solutions for construction materials." }
              ]
            },
            completed_projects_14: {
              title: "COMPLETED PROJECTS",
              items: [
                { title: "Developed just-in-time logistics for major infrastructure projects." },
                { title: "Integrated digital tracking for bulk material shipments." },
              ]
            },
            //Construction
            // Bulk
              title_15: "Bulk Cargo",
              intro_15: {
                main_text_15: "Reliable & Cost-Effective Logistics for Bulk Cargoes",
                text_1: "MMSH Logistics specializes in the transportation of bulk cargoes, including raw materials, minerals, agricultural products, and industrial goods. Our expertise in dry bulk, liquid bulk, and breakbulk shipping ensures the efficient movement of high-volume goods across global trade routes. We leverage specialized vessels, bulk carriers, and rail freight networks to optimize cost-efficiency and transit times. With dedicated port facilities, automated cargo handling systems, and real-time tracking, we provide seamless logistics solutions for industries requiring high-capacity shipping. Our customized bulk freight strategies help businesses minimize storage costs, streamline supply chains, and enhance sustainability through eco-friendly transport methods."
              },
              
              projects_15: {
                title: "Advancements in Bulk Cargo Logistics",
                items: [
                  { title: "Expansion of bulk carrier fleet for global trade." },
                  { title: "AI-driven optimization of loading and unloading operations." },
                  { title: "Integration of automated bulk handling at ports." },
                  { title: "Sustainable logistics solutions for bulk material transport." }
                ]
              },
              completed_projects_15: {
                title: "COMPLETED PROJECTS",
                items: [
                  { title: "Developed multimodal solutions for bulk cargo transport." },
                  { title: "Integrated digital tracking for real-time bulk shipment visibility." },
                ]
              },
              // Bulk
              // Expensive Cargo
              title_16: "Expensive Cargo",
              intro_16: {
                main_text_16: "Secure & Specialized Logistics for High-Value Goods",
                text_1: "MMSH Logistics provides premium transportation solutions for high-value and sensitive cargo, including luxury goods, jewelry, electronics, art, and financial assets. We understand that security, discretion, and efficiency are paramount when handling expensive shipments. Our logistics services include armored transport, climate-controlled storage, and dedicated security escorts to ensure maximum protection throughout the journey. Leveraging cutting-edge tracking technology, biometric access controls, and AI-powered risk assessment, we minimize transit risks and enhance shipment visibility. Whether transporting rare collectibles, confidential documents, or luxury fashion, MMSH Logistics offers a tailored approach to safeguard your valuable assets."
              },
             
              projects_16: {
                title: "Advancements in High-Value Cargo Logistics",
                items: [
                  { title: "Expansion of secure logistics for luxury goods." },
                  { title: "AI-powered risk analysis for high-value shipments." },
                  { title: "Integration of biometric security for warehouse access." },
                  { title: "Optimization of multimodal transport for expensive cargo." }
                ]
              },
              completed_projects_16: {
                title: "COMPLETED PROJECTS",
                items: [
                  { title: "Established global secure routes for jewelry transportation." },
                  { title: "Developed armored transport solutions for electronics." },
                ]
              },
              // Expensive Cargo
              // Heavy Cargo
              title_17: "Heavy Cargo",
              intro_17: {
                main_text_17: "Reliable & Specialized Logistics for Heavy Cargo",
                text_1: "MMSH Logistics offers tailored transportation solutions for oversized and heavy cargo, including industrial machinery, construction equipment, wind turbines, and large-scale infrastructure components. Our expertise in handling extreme weight and size requirements ensures that every shipment is securely transported with precision. We utilize specialized flatbed trailers, low-loaders, modular transport systems, and heavy-lift vessels to move goods safely and efficiently. Our logistics planning includes detailed route analysis, regulatory compliance, and escort coordination for oversized loads. Whether it’s cross-border heavy freight or large-scale industrial projects, we ensure smooth, cost-effective, and time-sensitive transportation."
              },
              
              projects_17: {
                title: "Advancements in Heavy Cargo Logistics",
                items: [
                  { title: "Expansion of specialized heavy transport fleet." },
                  { title: "AI-powered route optimization for oversized loads." },
                  { title: "Integration of real-time tracking for industrial machinery." },
                  { title: "Optimization of logistics for large-scale shipments." }
                ]
              },
              completed_projects_17: {
                title: "COMPLETED PROJECTS",
                items: [
                  { title: "Developed multimodal transport solutions for oversized cargo." },
                  { title: "Successfully executed international heavy machinery transport." },
                ]
              },
              // Heavy Cargo
              // Liquid Cargo
              title_18: "Liquid Cargo",
              intro_18: {
                main_text_18: "Specialized & Secure Logistics for Liquid Cargo",
                text_1: "MMSH Logistics provides safe and efficient transportation solutions for liquid cargo, including petroleum products, chemicals, food-grade liquids, and industrial fluids. Handling liquid shipments requires specialized tankers, temperature-controlled storage, and strict regulatory compliance. Our fleet includes dedicated ISO tank containers, flexitanks, and bulk liquid carriers designed for optimal safety and efficiency. With real-time monitoring systems, automated spill prevention, and advanced route optimization, we ensure secure and cost-effective delivery. Whether shipping hazardous chemicals, edible oils, or pharmaceutical-grade liquids, our logistics experts provide tailored transport solutions to meet industry standards and environmental regulations."
              },
              
              projects_18: {
                title: "Advancements in Liquid Cargo Logistics",
                items: [
                  { title: "Expansion of food-grade liquid transport fleet." },
                  { title: "Integration of IoT-based spill prevention systems." },
                  { title: "Optimized multimodal transport for chemical liquids." },
                  { title: "Development of eco-friendly liquid cargo storage solutions." }
                ]
              },
              completed_projects_18: {
                title: "COMPLETED PROJECTS",
                items: [
                  { title: "Established secure and fast transport routes for petroleum products." },
                  { title: "Successfully implemented real-time monitoring for liquid shipments." },
                ]
              },
              // Liquid Cargo
              // Passenger Cars
              title_19: "Passenger Cars",
              intro_19: {
                main_text_19: "Efficient & Secure Logistics for Passenger Car Transport",
                text_1: "MMSH Logistics specializes in the safe and efficient transportation of passenger vehicles, including luxury cars, electric vehicles (EVs), and commercial fleets. Our comprehensive logistics network ensures seamless car shipping via road, rail, sea, and air transport, catering to manufacturers, dealerships, and private clients. We provide enclosed transport for high-value and classic cars, ensuring protection from environmental damage. Our multimodal solutions optimize costs while maintaining the highest safety standards. Real-time GPS tracking, customized insurance options, and specialized vehicle handling ensure a secure and hassle-free transport experience. Whether moving single units or large fleets, MMSH Logistics guarantees on-time and damage-free delivery."
              },
              
              projects_19: {
                title: "Advancements in Passenger Car Transport",
                items: [
                  { title: "Expansion of enclosed transport fleet for luxury vehicles." },
                  { title: "Integration of AI-based route optimization for car shipping." },
                  { title: "Optimized multimodal transport for electric vehicles." },
                  { title: "Development of sustainable vehicle transport solutions." }
                ]
              },
              completed_projects_19: {
                title: "COMPLETED PROJECTS",
                items: [
                  { title: "Successfully established global vehicle transport routes for logistics." },
                  { title: "Integrated GPS tracking for real-time vehicle shipment monitoring." },
                ]
              },
              // Passenger Cars
              // Reefer Cargo
              title_20: "Reefer Cargo",
              intro_20: {
                main_text_20: "Reliable & Temperature-Controlled Logistics for Reefer Cargo",
                text_1: "MMSH Logistics specializes in the transportation of temperature-sensitive goods, including fresh produce, dairy products, pharmaceuticals, seafood, and frozen food. Our reefer logistics solutions ensure precise temperature control throughout the supply chain, maintaining product integrity from origin to destination. We utilize state-of-the-art refrigerated containers, cold storage facilities, and climate-controlled trucking to prevent spoilage and ensure compliance with food safety and pharmaceutical regulations. With AI-driven temperature monitoring, real-time tracking, and optimized multimodal transport, we guarantee efficiency, reliability, and cost-effectiveness. Whether shipping perishable food or medical supplies, our tailored logistics solutions meet the highest quality standards."
              },
              
              projects_20: {
                title: "Advancements in Reefer Cargo Logistics",
                items: [
                  { title: "Expansion of refrigerated transport fleet for perishables." },
                  { title: "AI-based temperature monitoring for pharmaceutical logistics." },
                  { title: "Optimized multimodal solutions for frozen and fresh foods." },
                  { title: "Development of energy-efficient refrigerated storage facilities." }
                ]
              },
              completed_projects_20: {
                title: "COMPLETED PROJECTS",
                items: [
                  { title: "Established global cold chain logistics for food and medical cargo." },
                  { title: "Integrated smart reefer tracking for real-time temperature monitoring." },
                ]
              },
              // Reefer Cargo
            //Drivers
              //Office
                title_21: "Drivers' Office",
                intro_21: {
                  main_text_21: "A Rewarding & Supportive Workplace for Professional Drivers",
                  text_1: "At MMSH Logistics, we recognize that our drivers are the backbone of our operations. We are committed to providing a professional, comfortable, and rewarding work environment. Our modern fleet, well-planned routes, and advanced logistics technology ensure efficiency and ease for every journey. With competitive salaries, career growth opportunities, and a strong support system, we make sure our drivers are well taken care of. Whether you're an experienced driver or looking to join the logistics industry, MMSH Logistics offers stability, respect, and a driver-focused work culture."
                },
                texts_21: {
                  main: "Key Advantages of MMSH Logistics",
                  mini_1: "Comfortable usage of our services",
                  mini_2: "Quick communication with dispatchers",
                  mini_3: "Access to 200+ new cargo orders daily",
                  mini_4: "Time-saving automated dispatch system",
                  mini_5: "Reduced loading/unloading delays with real-time notifications",
                  mini_6: "Accurate tracking to prevent disputes",
                  mini_7: "Smart financial planning with personalized payment schedules",
                  mini_8: "AI-powered route optimization to minimize costs" 
                },       
              //Office
              //Payments
              title_22: "Payments",
              intro_22: {
                main_text_22: "Seamless & Transparent Payment Services for Our Drivers",
                text_1: "At MMSH Logistics, we prioritize financial stability and ease for our drivers. Our advanced accounting and payment systems ensure timely, accurate, and transparent salary processing, eliminating the stress of financial uncertainty. With automated payroll, clear documentation, and dedicated support teams, drivers can focus on their journeys without worrying about administrative complexities. Our streamlined processes guarantee on-time payments, easy access to financial records, and hassle-free transactions. At MMSH Logistics, we value our drivers not just as employees but as essential partners in our success. Our commitment to efficiency, fairness, and financial security makes us a top choice for professionals in the logistics industry. If you have question(s) please call phone numbers below."
              },
              //Payments
              //Movement
              title_23: "Movement Restriction",
              intro_23: {
                main_text_23: "Understanding Movement Restrictions for Drivers in the Eurozone",
                text_1: "Driving and working in the Eurozone as a non-EU citizen comes with strict movement restrictions and legal requirements. To operate legally, drivers must comply with visa regulations, road transport laws, and border controls. A Euro visa (Schengen work visa) is mandatory for non-EU nationals seeking employment in European countries. In some cases, additional work permits may be required depending on national policies. Furthermore, environmental regulations, toll systems, and EU-imposed driving hour limitations can affect movement across borders. At MMSH Logistics, we support our drivers by providing guidance on visa applications, work permits, and compliance with transport laws, ensuring smooth operations and avoiding penalties. If you have any questions regarding movement restrictions and work permits, please contact us at the phone numbers below."
              },           
              //Movement
              //Fuels
              title_24: "Fuel Cards",
              intro_24: {
              main_text_24: "Fuel Card Policy for Drivers at MMSH Logistics",
              text_1: "At MMSH Logistics, we understand that unexpected situations can arise during long-haul trips. While we encourage all drivers to manage their fuel expenses independently, we provide fuel cards strictly in emergency situations. These cases include instances where a driver is temporarily unable to cover fuel costs due to unforeseen circumstances. Fuel cards are issued only as a last resort and require prior approval. Our priority is to support drivers in critical moments while maintaining responsible financial management. If you require assistance regarding fuel expenses, please contact the relevant department for guidance."
              },                
              //Fuels
              //Business_ethics
               title_25: "Business Ethics of MMSH",
               intro_25: {
                 main_text_25: "Our Commitment to Ethical and Responsible Logistics",
                 text_1: "At MMSH Logistics, integrity, responsibility, and respect form the foundation of our business ethics. We prioritize transparency in our operations, ensuring fairness in every transaction and partnership. Our commitment to sustainability drives us to adopt eco-friendly practices and efficient logistics solutions that reduce our environmental impact. We value the trust of our clients and employees, fostering a workplace built on mutual respect, diversity, and inclusivity. By upholding the highest ethical standards, we ensure that MMSH Logistics remains a trusted leader in the industry, dedicated to reliability, innovation, and long-term success."
               },     
              //Business_ethics
              //Career
              title_26: "Career in MMSH",
              intro_26: {
                main_text_26: "Building a Successful Career at MMSH Logistics",
                text_1: "At MMSH Logistics, we believe that a rewarding career is built on growth, innovation, and a supportive environment. We are committed to providing our employees with opportunities to develop their skills, advance professionally, and make a meaningful impact in the logistics industry. By fostering a workplace that values teamwork, creativity, and continuous learning, we ensure that every member of our team has the resources and guidance to thrive. With competitive benefits, a strong ethical foundation, and a vision for the future, MMSH Logistics is the ideal place to grow your career and shape the future of global logistics. To learn more search our vacancies or internships, which you can find below.",
                join_our_team: "Join our team",
                view_vacancies: "View Vacancies",
                apply_for_internship: "Apply for Internship"

              },   
             //Career
             //Vacancies
              title_27: "Career Opportunities at MMSH",
              intro_27: {
                main_text_27: "Explore Exciting Vacancies at MMSH Logistics",
                text_1: "At MMSH Logistics, we offer dynamic career opportunities for professionals seeking growth, innovation, and a supportive environment. We are committed to helping our employees develop their skills, advance in their careers, and make a meaningful impact in the logistics industry. Our workplace fosters teamwork, creativity, and continuous learning, ensuring that every team member has the resources and guidance to excel.",
                vacancies: "View Vacancies"
              }, 
            //Vacancies
            //Internship
            title_28: "Internship at MMSH",
            intro_28: {
              main_text_28: "Explore Exciting Vacancies at MMSH Logistics",
              text_1: "At MMSH Logistics, we offer dynamic career opportunities for professionals seeking growth, innovation, and a supportive environment. We are committed to helping our employees develop their skills, advance in their careers, and make a meaningful impact in the logistics industry. Our workplace fosters teamwork, creativity, and continuous learning, ensuring that every team member has the resources and guidance to excel."
            },
            internship_benefits: {
              main_title: "Why Intern at MMSH Logistics?",
              description: "An internship at MMSH Logistics is more than just a learning experience—it’s an opportunity to jumpstart your career in the dynamic world of international logistics. Whether you are a student, recent graduate, or someone looking to gain industry experience, our internship program provides hands-on training, professional mentorship, and real-world exposure to logistics operations.",
              benefits: {
                experience: {
                  title: "Practical Industry Experience",
                  description: "Gain direct exposure to logistics processes, including supply chain management, freight forwarding, customs clearance, and international trade regulations."
                },
                mentorship: {
                  title: "Mentorship from Industry Experts",
                  description: "Work alongside seasoned professionals who will guide you in developing essential technical and business skills."
                },
                career_growth: {
                  title: "Career Advancement Opportunities",
                  description: "Many of our interns transition into full-time roles, making this internship a stepping stone for a long-term career in logistics."
                },
                networking: {
                  title: "Networking & Professional Development",
                  description: "Connect with industry leaders, attend business meetings, and build relationships that can shape your future career."
                },
                innovation: {
                  title: "Innovative Learning Environment",
                  description: "We emphasize technology-driven solutions in logistics, giving you the chance to work with AI-powered tools, automation systems, and data analytics."
                },
                personal_growth: {
                  title: "Personal Growth & Skill Development",
                  description: "Enhance your problem-solving, communication, and critical thinking skills in a fast-paced, international work environment."
                }
              },
              conclusion: "At MMSH Logistics, we don’t just offer internships—we offer career-building experiences that prepare you for the global logistics industry. Start your journey with us today!"
            },
           //Internship

          // Locations
          locations: {
            city: "City",
            phone_number: "Phone Number",
            data: [
              { country: "cn", city: "Alashankou, China", phone: "+86 901 123 45 67" },
              { country: "us", city: "Ohio, USA", phone: "+1 614 555 78 90" },
              { country: "de", city: "Frankfurt, Germany", phone: "+49 69 123 45 67" },
              { country: "uz", city: "Andijon, Uzbekistan", phone: "+998 74 456 78 90" },
              { country: "tr", city: "Istanbul, Turkey", phone: "+90 212 987 65 43" }
            ],
            data2: [
              { country: "jp", city: "Kyoto, Japan", phone: "+81 75 234 56 78" },
              { country: "it", city: "Milan, Italy", phone: "+39 02 123 45 67" },
              { country: "it", city: "Rome, Italy", phone: "+39 06 789 01 23" },
              { country: "ru", city: "Moscow, Russia", phone: "+33 1 234 56 78" }, 
              { country: "cn", city: "ShengZhen, China", phone: "+86 901 234 56 78" }
            ]
          },
          // Locations       
          // Consulting
          consulting_title: "Consulting",
          consulting_heading: "Reliable Logistics Partner",
          consulting_description: "In today’s fast-paced world, businesses require reliable, efficient, and innovative logistics solutions to stay ahead of the competition. At MMSH Logistics, we understand that every shipment carries more than just goods—it carries your business’s reputation, customer trust, and growth potential. That’s why we provide seamless, cost-effective, and technology-driven logistics services designed to help businesses expand effortlessly across borders. With a strong presence in international transportation, MMSH Logistics ensures that businesses have access to smooth, timely, and hassle-free delivery solutions. Whether you are dealing with import-export operations, supply chain management, or freight forwarding, our company offers tailor-made logistics strategies to optimize your business’s efficiency and cost savings.",
          contact_email: "info@mmshlogistics.com",
          contact_phone: "+998 90 123 45 67",
          
          // Consulting

          // Customs Services
          customs_services_title: "Customs Services",
          customs_services_heading: "Efficient and Reliable Customs Solutions",
          customs_services_description: "At MMSH Logistics, we understand that navigating customs regulations is one of the most critical aspects of international trade. Our customs services ensure a smooth and hassle-free clearance process, allowing your goods to move efficiently across borders. With our expertise, businesses benefit from reduced delays, minimized costs, and full compliance with global trade regulations. Whether it's import or export, MMSH Logistics provides tailored solutions for customs documentation, tariff classification, duty optimization, and regulatory compliance. Our team of experts works closely with customs authorities to ensure a seamless clearance process, helping businesses save time and avoid unnecessary complications.",
          // Customs Services

          // Project Logistics
          project_logistics_title: "Project Logistics",
          project_logistics_heading: "Comprehensive Project Logistics Solutions",
          project_logistics_description: "At MMSH Logistics, we specialize in providing customized logistics solutions for large-scale industrial and infrastructure projects. Our expertise in project logistics ensures the seamless transportation of oversized, heavy, and time-sensitive cargo across international borders. We handle the entire supply chain, from route planning and freight management to customs clearance and on-site delivery. With a strong global network and advanced logistics technology, MMSH Logistics enables businesses to execute complex projects with efficiency, safety, and compliance. Whether it's transporting equipment for energy, construction, or industrial plants, we ensure your cargo reaches its destination on time and within budget.",
          // Project Logistics

          // Warehouse Services
          warehouse_services_title: "Warehouse Services",
          warehouse_services_heading: "Secure and Efficient Warehouse Solutions",
          warehouse_services_description: "At MMSH Logistics, we offer top-tier warehouse services designed to streamline your supply chain. Our modern storage facilities provide secure, temperature-controlled, and highly efficient warehousing solutions to meet the unique needs of businesses. Whether you require short-term storage, long-term inventory management, or cross-docking services, our facilities are equipped with the latest technology to ensure real-time tracking and seamless operations. MMSH Logistics specializes in optimizing warehouse operations, reducing costs, and improving delivery times. Our team of experts ensures that your goods are handled with precision and care, keeping your business running smoothly and efficiently.",
          // Warehouse Services

          // Insurance
            insurance_services_title: "Cargo Insurance Services",
            insurance_services_heading: "Comprehensive Cargo Insurance for Maximum Security",
            insurance_services_description: "As an essential part of logistics services, MMSH Logistics offers its clients reliable cargo insurance solutions. Our 'All Risks' insurance provides the most convenient and secure coverage, ensuring the full protection of your cargo during transportation. In case of unforeseen circumstances, this policy guarantees full compensation for losses.",
            
            insurance_services_providers: "MMSH Logistics collaborates with the leading insurance agency 'Inson' to provide high-quality cargo insurance. Through 'Inson,' we ensure that our clients receive top-tier coverage, with cargo insurance available for up to €1,500,000 per shipment. Our insurance solutions offer complete security and compliance with international logistics standards.",
            
            insurance_services_benefits_heading: "Key Benefits of Insuring Cargo with MMSH Logistics",
            insurance_services_benefits: "Competitive Rates: Due to our high volume of insured shipments, we offer clients highly competitive insurance rates that optimize total transportation costs. Flexible Payment Options: Insurance payments can be made at any stage of transportation, along with freight charges. Standard service includes sending the insurance policy via email or fax. The original document can be sent upon request. Claim Management System: Our specialists assist in arranging cargo damage inspections and processing insurance claims. In case of an incident, customers should follow MMSH Logistics' expert instructions. Risk Minimization: To avoid financial losses, MMSH Logistics partners with 'Inson' Insurance, ensuring cargo insurance coverage of up to €1,500,000 per shipment",
            
            insurance_services_coverage_heading: "Insurance Coverage Options",
            insurance_services_coverage: "MMSH Logistics provides cargo insurance under the following conditions: 'All Risks' Insurance: Full reimbursement of cargo value in case of total loss and restoration costs for damage. 'Limited Insurance': Compensation for loss or damage caused by qualified incidents.",
            
            insurance_services_additional_coverage: "Our insurance policies cover cargo during loading at the sender's facility and unloading at the recipient's location, during storage at transit warehouses, and during cargo transfer between different transport modes.",
            
            insurance_services_who_can_insure: "The policyholder can be any party with an interest in the safety of the cargo, such as the cargo owner. Upon request, MMSH Logistics can arrange insurance without specifying a beneficiary, allowing compensation to be paid to the responsible party at the time of loss.",
            
            insurance_services_rates_heading: "Cargo Insurance Rates",
            insurance_services_rates: "Basic insurance rates range from 0.25% to 0.35% of the invoice value. The final rate depends on various factors, including cargo value, type of goods, packaging, transportation volume, route, and other parameters. MMSH Logistics offers special pricing for long-term partners. Typically, franchise costs (uncompensated loss) are set to zero, ensuring full compensation for even minimal losses.",
            
            insurance_services_options_heading: "Available Insurance Options",
            insurance_services_options: "Coverage for 110% of the cargo's invoice value, Coverage for the invoice value + freight costs, Coverage for 110% of the invoice value + freight costs.",
            
            insurance_services_damage_handling_heading: "Handling Cargo Damage",
            insurance_services_damage_handling: "Our experienced insurance team manages cargo damage inspections, collects necessary claim documents, and negotiates with insurers. Through our partnership with 'Inson' Insurance, MMSH Logistics ensures that clients do not have to worry about cargo safety and receive full compensation for any losses, with coverage of up to €1,500,000 per shipment.",          
          // Insurance

          vehicle_types: {
            title: "VEHICLE TYPES",
            description: "For maritime transport, MMSH Logistics utilizes specially adapted container types, including:",
            items: [
              "ISO containers in various sizes",
              "Special containers for oversized, bulk, and loose cargo",
              "Tank containers for transporting liquid goods",
              "Refrigerated containers for perishable goods",
              "Containers designed for vehicle transport, small shipments, and hazardous materials"
            ]
          },

          capabilities: {
            title: "OUR CAPABILITIES",
            description: "MMSH Logistics offers a range of specialized railway transport services to ensure safe and efficient delivery.",
            items: [
              "Temperature-controlled transport using thermos wagons, isotherms, and refrigerated cars.",
              "Transporting vehicles, machinery, and equipment.",
              "Efficient transportation of perishable goods by rail.",
              "Handling of large, lightweight cargo volumes exceeding 120 m3.",
              "Utilizing expedited trains for long-distance shipments."
            ],
            final_note: "MMSH is committed to providing flexible, reliable, and tailored logistics solutions."
          },

          regulations: {
            title: "REGULATIONS/DOCUMENTATION",
            description: "Maritime freight transport is governed by numerous national and international legal regulations.",
            list: [
              { title: "Key Conventions", content: "In Uzbekistan, maritime transportation adheres to the United Nations Convention." },
              { title: "National Legislation", content: "In addition to international agreements, MMSH complies with Uzbekistan’s national laws." },
              { title: "Specialized Oversight", content: "MMSH Logistics carefully monitors changes in maritime regulations." },
              { title: "Documentation", content: "Our team provides end-to-end assistance with all required shipping documents." }
            ],
            conclusion: "With a focus on legal compliance and operational excellence, MMSH Logistics ensures that every shipment is carried out safely."
          },

          start: {
            trucks: "Trucks",
            train: "Trains",
            boats: "Ships",
            air: "Air",
            multimodal: "Multimodal",
            collective: "Collective loads"
          },

          big: {
            trucks: "Our company ensures fast and reliable deliveries with our fleet of state-of-the-art transports.",
            train: "Our company leverages the power of rail transport to deliver goods efficiently.",
            boats: "Our company harnesses the strength of maritime transport.",
            air: "Our company takes to the skies with fast and efficient air freight services.",
            multimodal: "Our company offers seamless multimodal transportation.",
            collective: "Our company embraces comfortable collective transportation."
          },

          logo_text: "MMSH Logistics",
          about_mmsh: "MMSH Logistics is dedicated to delivering excellence, reliability, and efficiency to its corporate clients. We take pride in offering guaranteed service quality, ensuring seamless and secure transportation solutions tailored to meet diverse business needs. With our experienced team, cutting-edge technology, and unwavering commitment to customer satisfaction, we optimize every stage of the supply chain, reducing costs and enhancing operational efficiency. At MMSH Logistics, your success is our priority.",

          career: "Career in MMSH",
          work: "Step into a world of endless opportunities and innovation at MMSH Logistics.",

          Responsible: "Responsible",
          Supportive: "Supportive",
          Comfortable: "Comfortable",
          
          responsible: "At MMSH, we take full responsibility for delivering seamless logistics solutions. Our team ensures timely and secure transportation, handling every detail with precision and care.",
          supportive: "We believe in strong partnerships and continuous support. Whether it’s international shipping or local transportation, our experts are always ready to assist and guide our clients at every step.",
          comfortable: "With our user-friendly services and efficient operations, we make logistics stress-free. Our customers can rely on us for smooth processes, transparent communication, and hassle-free shipments.",

          SignUp: "Sign up today",
          Learn_more: "Learn more",
          Search_more: "Search more",
          Back_to_top: "Back to top",
          View_details: "View details",
          loading: "Loading...",

          regions: {
            china_team_leader: "China Team Leader",
            central_asia_russia_team_leader: "Central-Asia and Russia Team Leader",
            europe_team_leader: "Europe Team Leader"
          },

          names: {
            abdulloh: "Abdulloh",
            nuriddin: "Nuriddin",
            ulugbek: "Ulug'bek"
          },

          texts: {
            trustworthy_company: "Trustworthy company with numerous certificates.",
            shipping_with_trains: "We also offer shipping with trains.",
            experienced_drivers: "Experienced drivers are ready to help you at any moment."
          },

          write: {
            km: "92.41",
            done: "12731",
            routes: "975",
            loaders: "3211",
            drivers: "7445"
          },

          write_2: {
            km_text: "Million kilometers",
            done_text: "Completed orders",
            routes_text: "Targeted trade lanes",
            loaders_text: "Corporate clients",
            drivers_text: "Reliable contractors"
          },

          write_3: {
            more: "More about it",
            see_statistics: "See statistics",
            learn_more: "Learn more",
            see: "See",
            check: "Check"
          },
          Special: {
            Industry_Solutions: "Industry Solutions",
            Special_Loads: "Special Loads",
            Learn_more: "Learn more",
          },
          Career: {
            make_career: "Career in MMSh",
            text: "Professionals in MMSH can pursue roles in marketing strategy, sales management, customer relations, event planning, and hospitality management. The field demands strong communication, leadership, and organizational skills, with a focus on building customer relationships and driving business growth.",
            learn_more: "Learn more"
          },
          News: {
            News_in_Company: "News in Company",
            Growth_in_MMSH: "Growth in MMSH",
            MMSH_is: "MMSH is open for ambitious people",
            News_of_MMSH: "News of MMSH",
            learn_more: "Learn more",
            show_less: "Show less",  // Added the Show Less translation
            text_1: "The MMSH company is excited to announce the addition of new state-of-the-art trucks to its fleet. These vehicles are equipped with advanced technology, ensuring enhanced efficiency, safety, and eco-friendliness.",
            text_2: "MMSH proudly recognizes the dedication and expertise of its employees, who are the driving force behind the company’s success. With a focus on continuous professional development, MMSH provides its team with training opportunities, fostering innovation and excellence.",
            full_text_1: "MMSH Logistics continues to grow and expand its operations worldwide. The new trucks will improve our ability to serve customers faster and more reliably. We’re committed to maintaining high standards of safety, sustainability, and performance in all our fleet operations.",
            full_text_2: "As part of our efforts to foster a culture of excellence, MMSH is proud to offer a range of professional development programs for our employees. From leadership workshops to technical training, we support the growth of our team members to ensure they can contribute to our shared vision of success."
          },
          sections: {
              mmsh: "MMSH",
              transport: "Transport",
              industry_solutions: "Industry Solutions",
              special_loads: "Special Loads",
              for_drivers: "For Drivers",
              contacts: "Contacts",
              career: "Career"
            },
          links: {
              about_company: "About Company",
              history_mission: "History and Mission",
              certificates: "Certificates",
              trucks: "Trucks",
              trains: "Trains",
              ships: "Ships",
              air: "Air",
              multimodal: "Multimodal",
              chemicals: "Chemicals",
              technology: "Technology",
              groceries: "Groceries",
              agriculture: "Agricultural Products",
              construction: "For Construction",
              pharmaceuticals: "Pharmaceuticals",
              fashion: "Fashion Industry",
              expensive: "Expensive",
              passenger_cars: "Passenger Cars",
              liquid_cargo: "Liquid Cargo",
              bulk_cargo: "Bulk Cargo",
              heavy_cargo: "Heavy Cargo",
              reefer_cargo: "Reefer Cargo",
              carriers_office: "Carrier's Office",
              payments: "Payments",
              movement_restrictions: "Movement Restrictions",
              fuel_cards: "Fuel Cards",
              mmsh_offices: "MMSH Offices",
              contact_experts: "Contact with Experts",
              business_ethics: "Business Ethics",
              career: "Career",
              vacancies: "Vacancies",
              internship: "Internship"
            },

        business_description: "MMSH Logistics is committed to meeting the diverse needs, expectations, and business objectives of our customers and stakeholders. Through a combination of cutting-edge technology, industry expertise, and a customer-first approach, we ensure seamless and efficient logistics operations across global markets. Our tailored solutions address complex supply chain challenges, optimize transportation networks, and enhance operational efficiency.",
        certifications: "CERTIFICATIONS",
        certificate_description: "These certifications ensure compliance with global standards.",
        associations: "ASSOCIATIONS",
        associations_description: "MMSH collaborates with leading organizations in logistics, trade, and transport to ensure compliance and efficiency in international markets.",
        no_certificates: "No certifications available.",
        no_associations: "No associations available.",

        // Certificate List
        certificates_list: [
          {
            title: "MMSH's official certificate",
            description: "This certification guarantees high standards of quality, safety, and sustainability. It verifies that our management systems meet international quality and environmental standards.",
            document: "official"
          },
          {
            title: "GDP - Good Distribution Practice",
            description: "Ensures proper distribution and handling of pharmaceutical products. This certification confirms compliance with safety and hygiene standards during transportation.",
            document: "proof"
          },
          {
            title: "Comprehensive Cargo Insurance",
            description: "Protects shipments against loss, damage, or theft during transit. Our insurance coverage ensures financial security and risk management for international logistics operations.",
            document: "insurance"
          },
          {
            title: "TAPA - Transported Asset Protection Association",
            description: "Certificate ensuring supply chain security and risk management. Recognized for protecting high-value goods from theft and tampering in transit.",
            document: "license"
          },
          {
            title: "Our ATI.SU certificate for being first in Uzbekistan",
            description: "Certificate ensuring supply chain security and risk management. Recognized for protecting high-value goods from theft and tampering in transit.",
            document: "license"
          },
          {
            title: "Our ATI.SU certificate for being in top 10 companies in Uzbekistan",
            description: "Certificate ensuring supply chain security and risk management. Recognized for protecting high-value goods from theft and tampering in transit.",
            document: "license"
          },          
        ],        

        // Association List (Now with 11 elements)
        associations_list: [
          "FPAL - Since FPAL was set up by the UK oil and gas industry, it has been helping operators promote successful contract delivery and improve business performance.",
          "EIC - Energy Industries Council (UK), which supports global energy supply chains in logistics and compliance.",
          "NCBFAA - National Customs Brokers and Forwarders Association of America, ensuring adherence to international freight forwarding regulations.",
          "FIATA - The International Federation of Freight Forwarders Associations, connecting logistics providers worldwide.",
          "AIFFU - The Association of International Freight Forwarders of Ukraine, strengthening transport relations in Eastern Europe.",
          "ZMPD - The Association of International Road Transport Carriers in Poland, optimizing logistics routes between Europe and China.",
          "TAPA - The Transported Asset Protection Association, providing security protocols for supply chain protection.",
          "BVL - The Federal Logistics Association of Germany, advancing sustainable logistics solutions across the EU.",
          "TIACA - The International Air Cargo Association, uniting participants of air-freight operations from around the world.",
          "BRITA - Belt and Road International Transport Alliance, facilitating seamless transport links between China and Europe.",
          "LANDBRIDGE - Landbridge Logistics Alliance, supporting trans-Eurasian transport and customs clearance for Chinese and European partners."
        ],

        // Additional paragraph descriptions for associations
        associations_paragraphs: [
          "MMSH actively collaborates with top logistics organizations to ensure global trade efficiency. Our partnerships in China and Europe allow us to streamline customs, warehousing, and last-mile deliveries.",
          "Through memberships in major logistics alliances, MMSH guarantees seamless supply chain solutions that meet international trade regulations and safety standards.",
          "With a strong presence in China’s Belt and Road Initiative, we optimize logistics routes for European partners, ensuring faster and more cost-effective freight transport.",
          "Our association with European logistics federations allows us to maintain compliance with EU transportation laws, enhancing our cross-border shipment processes."
        ],
        //Sidebar
        home: "Home",
        orders: "Orders",
        messages: "Messages",
        profile: "Profile",
        contacts: "Contacts",
        home_desc: "Go to homepage",
        orders_desc: "View cargo orders",
        messages_desc: "Check your messages",
        profile_desc: "View your profile",
        contacts_desc: "Find contact details",
        //Sidebar

        //Login
        login_title: "Login as a Staff",
        username: "Username",
        password: "Password",
        login_btn: "Login",
        footer_text: "© 2025 MMSH Company",
        error_required: "Username and password are required",
        //Login

        //Code Verify
        success: "Success",
        success_message: "You successfully registered as a staff member.",
        return_btn: "Return",
        //Code Verify

        //Wrong
        error: "Error",
        error_message: "Sorry, you are not a staff member.",
        retry_btn: "Retry",
        //Wrong

        //Profile
        welcome: "Welcome, {{username}}!",
        profile_message: "We are glad to see you in MMSH 😇",
        logout: "Logout",
        //Profile

        Details: "Details", 
        
        // Experts
        experts: {
          john_doe: {
            name: "Ravshanbek Ahmadjonov",
            expertise: "Train Logistics",
            mission: "Expert in high-cost cargo transportation across Europe."
          },
          jane_smith: {
            name: "Oyatillo Xamidjanov",
            expertise: "Freight & Transport",
            mission: "Professional freight manager ensuring smooth trade between the U.S. and China."
          },
          michael_lee: {
            name: "Chirmashev Bekzod",
            expertise: "Director",
            mission: "Specialist in international trade relations."
          },
          sophia_brown: {
            name: "Oyqiz Mo'minova",
            expertise: "International Shipping",
            mission: "Leader in handling oversized cargo shipments from China to Europe."
          },
          liam_garcia: {
            name: "Guli Adhamjonova",
            expertise: "Customs & Compliance",
            mission: "Expert in European customs regulations for high-value goods."
          },
          olivia_martinez: {
            name: "Zuhra Qudratillayeva",
            expertise: "Warehouse Operations",
            mission: "Top warehouse automation strategist for large-scale distribution centers in America."
          },
          william_harris: {
            name: "Kuldashev Bahodirjon",
            expertise: "Cold Chain Logistics",
            mission: "Professional in pharmaceutical cold chain logistics for the German market."
          },
          emma_wilson: {
            name: "Sardor Husanboyev",
            expertise: "Last mile delivery in USA",
            mission: "Leading expert in fast last-mile delivery solutions across the U.S."
          },
          ethan_carter: {
            name: "Abdurahmonov Kamronbek",
            expertise: "Logistics in Europe",
            mission: "Highly experienced logist managing cross-border freight between the U.S. and Russia."
          },
          ava_robinson: {
            name: "Abbosbek Munavvarov",
            expertise: "Logistics in Russia",
            mission: "Professional logistics manager specializing in express deliveries across Europe."
          },
          noah_adams: {
            name: "Ismoilov Asilbek",
            expertise: "Logistics & Supply Chain",
            mission: "Senior strategist optimizing logistics flows between China and Europe."
          },
          isabella_thompson: {
            name: "Ibrohimjon Mavlonov",
            expertise: "Freight & Transport",
            mission: "Specialist in intercontinental rail freight from China to Germany."
          },
          lucas_white: {
            name: "Ulug'bek Olimov",
            expertise: "Fleet Management",
            mission: "Fleet operations expert focusing on electric truck adoption in the U.S."
          },
          mia_johnson: {
            name: "Farrux Xayitov",
            expertise: "International Shipping",
            mission: "Expert in reducing shipping delays at major European ports."
          },
          benjamin_hall: {
            name: "Zaynobidin Kamoldinov",
            expertise: "Manager",
            mission: "Professional in tariff negotiations and compliance for China-Europe trade."
          },
          ibrohimjon: {
            name: "Ibrohimjon Isaqov",
            expertise: "Manager development",
            mission: "Manager development in Russia, Turkey, and Europe"
          },
          doniyor: {
            name: "Doniyor Jo'rayev",
            expertise: "Shipping Manager",
            mission: "Manager on Russian, Belorussian and Central Asian Trade"
          },
          Hide_Contact: "Hide Contact",
          Contact: "Contact",
          Contact_with_Experts: "Contact with Experts",
        },
        // Footer
        quick_links: "Quick Links",
        about: "About",
        contact: "Contact",
        news: "News",
        certificates: "Certificates",
        resources: "Resources",
        blog: "Blog",
        careers: "Careers",
        support: "Support",
        business_ethics: "Business Ethics",
        register_as_staff: "Register as Staff",
        staff_only: "Only for registered members",
        staff: "Staff",
        all_rights_reserved: "All rights reserved.",
        // Footer
        // Cargo types
        cargo_types: {
          title: "Cargo Types",
          description: "MMSH Logistics provides exceptional services for various types of cargo, ensuring safe, efficient, and timely transportation worldwide.",
          items: [
            "Bulk Cargo - Efficient transport for large quantities of unpackaged goods.",
            "Liquid Cargo - Safe handling and transportation of liquids and chemicals.",
            "Refrigerated Cargo - Temperature-controlled shipping for perishable goods.",
            "Containerized Cargo - Secure and standardized transport in shipping containers.",
            "Hazardous Cargo - Specialized logistics for dangerous and regulated materials.",
            "Project Cargo - Customized solutions for oversized and complex shipments.",
            "General Cargo - Reliable transport for standard goods and merchandise."
          ]
        },
        header: {
          Andijon: "Andijon",
          Alashankou: "Alashankou",
          Tashkent: "Tashkent",
        },
        advantages: {
          title: "OUR ADVANTAGES",
          experience: {
            title: "Experience",
            description: "MMSH Logistics has over 17 years of experience in railway transportation..."
          },
          safety: {
            title: "Safety",
            description: "Our experts ensure the safety and integrity of goods during transportation..."
          },
          comprehensiveness: {
            title: "Comprehensiveness",
            description: "In addition to transportation services, MMSH Logistics provides warehousing..."
          },
          insurance: {
            title: "Insurance",
            description: "Every cargo transported by MMSH is insured for up to EUR 3,000,000..."
          }
        },
        map: "OUR GEOGRAPHIC REACH",
        // Sidebar Products
        submission_failed: "Submission failed. Try again.",
        fill_form_specialist: "Fill out the form to connect with a specialist.",
        your_question: "Your Question",
        your_name: "Your Name",
        your_email: "Your Email",
        next: "Next",
        submitting: "Submitting...",
        submit: "Submit",
        thank_you: "Thank you! The dispatcher will contact you soon.",
        logistics_solutions: "Logistics Solutions",
        trucks: "Trucks »",
        trains: "Trains »",
        ships: "Ships »",
        air: "Air »",
        multimodal: "Multimodal »",
        additional_services: "Additional Services",
        consulting: "Consulting »",
        customs_services: "Customs Services »",
        insurance: "Insurance »",
        project_logistics: "Project Logistics »",
        warehouse_services: "Warehouse Services »",
        // Sidebar Products 
        // Request for cargo transportation
        request: "Request for transportation",
        form: {
          aboutCompany: "About Your Company",
          companyName: "Company Name",
          companyAddress: "Company Address",
          contactInfo: "Contact Information",
          contactName: "Contact Name",
          contactSurname: "Contact Surname",
          contactPhone: "Contact Phone",
          email: "Email",
          cargoDetails: "Cargo Details",
          fromCountry: "Select From Country",
          toCountry: "Select To Country",
          cargoType: "Type of Cargo",
          description: "Description",
          privacyPolicy: "By filling out this form, I confirm that I agree to the privacy policy.",
          promotions: "I agree to receive news, offers, and promotional information from MMSH by email.",
          send: "Send",
          sending: "Sending...",
          success: "Form submitted successfully!",
          error: "Failed to submit form."
        },
        succes: "You have successfully requested cargo transportation. A dispatcher will contact you soon.",
        // Request for cargo transportation
        // Check cargoes
          loading_cargo: "Loading...",
          errorFetchingCargo: "Error fetching cargo requests.",
          cargoRequests: "Cargo Requests",
          cargoType: "Cargo Type",
          viewDetails: "View Details",
        // Check cargoes
        // Check cargo details
          cargo_details: "Are you sure you want to delete this cargo request?",
          Cargo_Details: "Cargo Details",
          company_name: "Company Name",
          company_address: "Company Address",
          contact_name: "Contact Name",
          contact_phone_detail: "Contact Phone",
          email: "Email",
          cargo_type: "Cargo Type",
          description: "Description",
          agree_privacy_policy: "Agree to Privacy Policy",
          agree_promotions: "Agree to Promotions",
          save_changes: "Save Changes",
          cancel: "Cancel",
          yes: "Yes",
          no: "No",
          delete_cargo: "Delete Cargo",
          edit_cargo_details: "Edit Cargo Details",
        // Check cargo details
        // Vacancies
          career_opportunities: "Career Opportunities at MMSH",
          vacancies: "Vacancies",
          join_our_team: "Join Our Team",
          explore_opportunities: "Explore exciting opportunities with us.",
          search_vacancies: "Search for vacancies...",
          vacancy: "Vacancy",
          audience: "Audience",
          job_category: "Job Category",
          location: "Location",
          active: "Active",
          not_active: "Not Active",
          no_vacancies: "No vacancies found",           
        // Vacancies
        // ChatBot
          ask: "Ask about MMSH",
          sorry: "Sorry, I couldn't understand that.",
        // ChatBot
        // About page
          header_title: "Safe, ambitious, and efficient shipping company.",
          header_description: "MMSH Logistics is a reliable and efficient shipping company, dedicated to providing safe and innovative transportation solutions.",
          about_company: "About Company",
          read_more: "Read More",
          read_less: "Read Less",
          
          quality: "Quality",
          quality_short: "MMSH Logistics ensures top-quality, safe, and efficient shipments.",
          quality_full: "At MMSH Logistics, quality control is at the heart of everything we do. We implement rigorous standards and continuous monitoring to ensure that every shipment is handled with precision and care. Our dedicated team ensures that all processes, from packing to delivery, meet the highest quality benchmarks, guaranteeing safe and efficient transportation for our clients.",
          
          caring_nature: "Caring Nature",
          caring_nature_short: "We prioritize sustainability and eco-friendly practices in every aspect of our operations.",
          caring_nature_full: "At MMSH Logistics, we are committed to sustainability. We integrate eco-friendly practices throughout our operations, from reducing emissions to optimizing resource use. Our focus on green logistics ensures that we contribute to a cleaner environment while providing efficient and reliable services to our clients.",
          
          assistance: "Assistance",
          assistance_short: "A brief overview of this blog post.",
          assistance_full: "At MMSH Logistics, we pride ourselves on being a helpful partner to our clients. Our team is dedicated to providing reliable assistance at every stage, from planning to delivery. We offer solutions tailored to meet the unique needs of each client, ensuring a seamless and supportive experience.",
          
          innovations: "Innovations",
          innovations_short: "Our company is open to new ideas.",
          innovations_full: "At MMSH Logistics, we embrace innovation as a core element of our operations. We are constantly exploring new technologies and solutions to improve efficiency, reduce environmental impact, and enhance our service offerings.",
          
          associations_about: "Associations",
          associations_short: "MMSH Logistics partners with globally recognized companies to offer top-tier logistics solutions.",
          associations_full: "MMSH Logistics works closely with world-renowned companies to deliver superior logistics solutions. Our strategic partnerships enhance our global reach, ensuring that we provide cutting-edge transportation services.",
          
          forward_thinking: "Forward-thinking",
          forward_thinking_short: "Our company focuses on growth, innovation, and global expansion.",
          forward_thinking_full: "Our company is focused on long-term growth and continuous improvement. With an eye on the future, we are expanding our operations and investing in new technologies to enhance our services.",        
        // About page
        // Messages
          fetch_error: "Failed to fetch messages",
          confirm_delete: "Are you sure you want to delete this message?",
          delete_error: "Failed to delete message",
          delete_error_log: "Error deleting message:",
          question: "Question",
          no_messages: "No messages found.",        
        // Messages
        // Contacts
          Search_contacts: "Search contacts...",
          Contacts: "Contacts",
          Add_Contact: "Add Contact",
          Please: "Please, don't share contacts",
          Save: "Save",
          Username: "Username",
          Phone_1: "Phone 1",
          Phone_2: "Phone 2 (Optional)",
          edit: "Edit Contact",
          delete: "Delete Contact",
        // Contacts
        // History
        birth_title: "The Birth of MMSH Logistics",
        birth_text: "In 2019, three visionary brothers—Minhojidin, MuhammadAli, and Shukurillo—founded MMSH Logistics. They had a dream of building a logistics company that could connect businesses across the world.",
        challenges_title: "Challenges and Perseverance",
        challenges_text: "Starting a logistics company was not easy. They faced numerous financial difficulties, operational roadblocks, and the challenge of gaining trust in a competitive industry. But their dedication and hard work never wavered.",
        expand_title: "Expanding Horizons",
        expand_text: "Despite the obstacles, MMSH Logistics grew rapidly. By forming strategic partnerships and continuously improving their services, they began working with businesses in different parts of the world.",
        global_title: "Going Global",
        global_text: "Today, MMSH Logistics partners with 34 countries across Europe, Asia, and beyond. Their global presence is a testament to their commitment to excellence in logistics.",
        career_title: "Building Careers",
        career_text: "MMSH Logistics is not just about transportation. It has become a hub for young and talented professionals, offering career opportunities in management, marketing, IT, and multilingual communication.",
        future_title: "The Future of MMSH Logistics",
        future_text: "With innovation, strong leadership, and a passion for logistics, MMSH Logistics continues to grow. The future holds even more opportunities for expansion and transformation in the global market.",
        click_text: "Click this book to learn more about MMSH's history",
        // History
    }   
};

export default en;